import { Component, OnInit, Input, Pipe } from "@angular/core";
import {
	FormGroup,
	FormArray,
	Validators,
	FormControl,
	FormGroupDirective,
	NgForm
} from "@angular/forms";
import { MemberappBaseComponent } from "../groupportal-base/groupportal-base.component";
import {
	AcepSSOService,
	GlobalDomOpsService,
	GlobalDataOpsService,
	CommonOperationsService
} from "@acepteam/globalspack";
import {
	ChapterDetails,
	ChapterInfo
} from "../../../shared/models/chapter-details";
import { MembersService } from "./members.service";
import { Observable, Observer, Subject, Subscription, of } from "rxjs";
import { group } from "@angular/animations";
import {
	Group,
	GroupInfo,
	AcepContact
} from "../../../shared/models/group-portal-data.models";
import { environment } from '../../../../environments/environment'
import { stat } from "fs";
import { select, now, html } from "d3";
declare var $: any;
declare var moment: any;
export interface MemberFilter {
	mfvalue: string;
	mftext: string;
}
@Component({
	selector: 'members .d-flex.pl-3',
	templateUrl: './members.component.html',
	styleUrls: ["./members.component.scss"]
})
export class MembersComponent extends MemberappBaseComponent {
	selectedContactDetails: AcepContact;
	selectedContactAddresses: any[];
	//chkAllMembers: boolean;
	allMembers: any;
	selectedMember: any;
	removeMode: boolean;
	selectedGroup: Group;
	memberFilterType: string = "-1";
	memberFilterText: string = "All Members";
	public myelement: any;
	recallPayment: boolean;

	// look here for example of what was done:
	//https://material.angular.io/components/select/overview#form-field-features
	//ddlMemberTypes = new FormControl('',)

	//pga: Feature-2920 added submitted status support
	memberFilter: MemberFilter[] = [
		{ mfvalue: "-1", mftext: "All Members" },
		{ mfvalue: "1", mftext: "Ready For Payment" },
		{ mfvalue: "2", mftext: "Application Pending" },
		{ mfvalue: "3", mftext: "Paid Members" },
		{ mfvalue: "5", mftext: "Submitted" },
		{ mfvalue: "0", mftext: "Not in Group Bill" }
	];
	MemberControl = new FormControl("", [Validators.required]);

	initSubscriptions() {
		this.groupPortalDataService
			.getSelectedContactDetails()
			.subscribe(selectedContactDetails => {
				this.selectedContactDetails = selectedContactDetails;
			});

		this.groupPortalDataService
			.getSelectedContactAddresses()
			.subscribe(selectedContactAddresses => {
				this.selectedContactAddresses = selectedContactAddresses;
			});
		// this.groupPortalDataService.getchkAllMembers().subscribe(chkAllMembers => { this.chkAllMembers = chkAllMembers });
		// this.groupPortalDataService.getAllMembers().subscribe(allMembers => { this.allMembers = allMembers; });
		// this.groupPortalDataService.getSelectedGroup().subscribe(selectedGroup => { this.selectedGroup = selectedGroup; });
	}

	//AkshayG: Remove extra space on page load for modal pop up
	ngAfterViewInit(): void {
		const deleteConfirmModal = $('[data-remodal-id=deleteParticipant]');
		const recallconfirmmodal = $('[data-remodal-id=recallPayment]');
	
		//hide modal pop up div
		if (deleteConfirmModal) {
			this.setModalVisibility(deleteConfirmModal,'none','hidden')
		}

		if (recallconfirmmodal) {
			this.setModalVisibility(recallconfirmmodal,'none','hidden')
		}

	  }
	ngOnInit() {
		this.checkIfAllChecked();
		console.log('init of members page:', this.groupPortalDataService.groupList.allMembers.length);
	}

	toggleMembers() {
		for (
			var i = 0;
			i < this.groupPortalDataService.groupList.allMembers.length;
			i++
		) {
			if (
				this.groupPortalDataService.groupList.allMembers[i].status ===
				this.groupPortalDataService.statusCodeEnum.ReadyForPayment &&
				this.groupPortalDataService.groupList.allMembers[i].AddToOrder !==
				null
			) {
				this.groupPortalDataService.groupList.allMembers[
					i
				].AddToOrder = this.groupPortalDataService.chkAllMembers;
			}
		}
		this.groupPortalDataService.enableProcessPayment = this.groupPortalDataService.chkAllMembers;
		this.checkIfAllChecked();
	}

	checkIfAllChecked() {
		let membersSelected = 0;
		let selectedAmount = 0;
		let selectedMembers = [];
		this.groupPortalDataService.groupList.ResidentInvoiceData = [];
		for (
			var i = 0;
			i < this.groupPortalDataService.groupList.allMembers.length;
			i++
		) {
			if (
				this.groupPortalDataService.groupList.allMembers[i].status ===
				this.groupPortalDataService.statusCodeEnum.ReadyForPayment &&
				this.groupPortalDataService.groupList.allMembers[i].AddToOrder
			) {
				membersSelected++;
				selectedAmount += this.groupPortalDataService.groupList.allMembers[i].amount;
				selectedMembers.push(this.groupPortalDataService.groupList.allMembers[i]);
				if (!this.groupPortalDataService.groupList.GroupInfo.physgrpDetail) {
					this.setResidentGradYears(this.groupPortalDataService.groupList.allMembers[i]);
				}
			}
		}
		if (
			membersSelected === this.groupPortalDataService.gpdsMemberCounts.ready &&
			membersSelected !== 0
		) {
			this.groupPortalDataService.chkAllMembers = true;
		} else {
			this.groupPortalDataService.chkAllMembers = false;
		}
		this.groupPortalDataService.enableProcessPayment = membersSelected > 0;
		this.groupPortalDataService.groupList.selectedMembers = selectedMembers;
		if (!this.groupPortalDataService.hasSubmittedStstus) {
			this.groupPortalDataService.groupList.selectedAmount = selectedAmount;
		} else {
			this.groupPortalDataService.groupList.selectedAmount = this.groupPortalDataService.groupList.outstandingTotal;
		}

		this.sortByGradYear();
		this.sortResidentMembers();
	}

	filterGroupMembers(m: any) {
		//let m = this.groupPortalDataService.groupList.selectedMembers

		//make unique by last name
		let uniqued = [];
		for (let i = 0; i < m.length; i++) {
			let a = uniqued.find(a => a.contactNo == m[i].contactNo);
			if (!!!a) {
				uniqued.push(m[i]);
			}
		}

		//sort by last name
		uniqued = this.groupPortalDataService.sortByLastName(uniqued);
		return uniqued;

	}






	sortResidentMembers() {
		for (var i = 0; i < this.groupPortalDataService.groupList.ResidentInvoiceData.length; i++) {
			var lastNameSortedMembers = this.groupPortalDataService.sortByLastName(this.groupPortalDataService.groupList.ResidentInvoiceData[i].yearMembers);
			this.groupPortalDataService.groupList.ResidentInvoiceData[i].yearMembers = lastNameSortedMembers;
		}


	}

	sortByGradYear() {
		return this.groupPortalDataService.groupList.ResidentInvoiceData.sort((a: any, b: any) =>
			a.gradYear < b.gradYear ? -1 : a.gradYear > b.gradYear ? 1 : 0
		);
	}

	setResidentGradYears(selectedMember) {
		var rid = this.groupPortalDataService.groupList.ResidentInvoiceData;
		var varGradYear = selectedMember.gradYear;
		var addYear = true;

		for (var i = 0; i < this.groupPortalDataService.groupList.ResidentInvoiceData.length; i++) {
			if (rid[i].gradYear === varGradYear) {
				addYear = false;
				rid[i].yearMembers.push(selectedMember);
				break;
			}
		}
		if (addYear) {
			var gradYearGroup = {
				gradYear: varGradYear,
				yearMembers: [selectedMember]
			}
			this.groupPortalDataService.groupList.ResidentInvoiceData.push(gradYearGroup);
		}
	}

	processPayment() {
		let MemberIds = null;
		let totalAmount = 0;
		let masterOrder = this.groupPortalDataService.masterOrder;
		let indOrders = this.groupPortalDataService.masterOrder.groupOrder.individualOrders;
		var orders = [];
		for (
			var i = 0;
			i < this.groupPortalDataService.groupList.allMembers.length;
			i++
		) {
			if (this.groupPortalDataService.groupList.allMembers[i].AddToOrder) {
				for (var n = 0; n < indOrders.length; n++) {
					if (indOrders[n].individualNo == this.groupPortalDataService.groupList.allMembers[i].contactNo) {
						orders.push(indOrders[n]);
					}
				}
				// if (MemberIds) {
				// 	MemberIds +=
				// 		"," +
				// 		this.groupPortalDataService.groupList.allMembers[i]
				// 			.contactNo;
				// } else {
				// 	MemberIds = this.groupPortalDataService.groupList.allMembers[
				// 		i
				// 	].contactNo;
				// }
				totalAmount += this.groupPortalDataService.groupList.allMembers[i].amount;
			}
		}
		masterOrder.groupOrder.totalAmount = totalAmount;
		masterOrder.groupOrder.individualOrders = orders;
		this.paymentPayload(masterOrder, totalAmount);
	}

	paymentPayload(masterOrder, totalAmount) {
		var org = this.groupPortalDataService.groupList.GroupInfo.physgrpDetail ?
			(this.groupPortalDataService.groupList.GroupInfo.physgrpDetail.sempaDuesPaid == 'Yes' ? 'SEMPA' : 'ACEP') : 'EMRA';
		masterOrder.groupOrder.adminContactNo = this.ssoService.acepid;
		let pco = {
			authorizationToken: environment.checkoutToken,
			backUrl: window.location.href,
			returnUrl: window.location.href,
			customerNumber: this.groupPortalDataService.headerInfo.groupId,
			memberIds: this.groupPortalDataService.headerInfo.groupId,
			brand: "",
			totalAmount: totalAmount,
			orderType: "MembershipGroup",
			gpOrganization: "MEMB",
			organization: org,
			priceList: "MEMBERSHIP",
			lineItems: [],
			promoCode: "",
			lockPromoCode: false,
			lockAutoRenewal: false,
			autoRenewalDescription: "",
			description:
				"Pass ApplicationId of HighMark here or in the transaction id field",
			transactionId: "Pass ApplicationId of HighMark here",
			groupOrder: masterOrder.groupOrder
		};
		$.redirect(this.globalDataOpsService.BasePath + "/membership/handlers/payment.ashx", { paymentconfiguration: JSON.stringify(pco) }, "POST");
	}

	confirmRemoveParticipant(member: any) {		
		//AkshayG: Open modal pop up on user action
			let deleteconfirmmodal = $("[data-remodal-id=deleteParticipant]");

			this.setModalVisibility(deleteconfirmmodal,'inline-block','show') 

			this.removeMode = true;
			this.selectedMember = member;
			// Open the modal after applying styles
			deleteconfirmmodal.remodal().open();
	}

	//pga: Feature-2920 methonds for recall and apply payments
	confirmRecallPayment() {
		this.recallPayment = true;
		let recallconfirmmodal = $(
			"[data-remodal-id=recallPayment]"
		);
        //AkshayG: Open modal pop up on user action
		this.setModalVisibility(recallconfirmmodal,'inline-block','show') 
		recallconfirmmodal.remodal().open();
	}
	confirmApplyPayment() {
		this.recallPayment = false;
		let recallconfirmmodal = $(
			"[data-remodal-id=recallPayment]"
		)
		 //AkshayG: Open modal pop up on user action
		this.setModalVisibility(recallconfirmmodal,'inline-block','show') 
		recallconfirmmodal.remodal().open();
	}

	callRecallApplyPayment(isRecall: boolean) {
		this.groupPortalDataService.recallOrApplyPayment(this.groupPortalDataService.groupList.groupNumber, isRecall);
		let recallconfirmmodal = $(
			"[data-remodal-id=recallPayment]"
		).remodal();
		recallconfirmmodal.close();
	}
	//
  

	retunToAllMembers() {
		this.groupPortalDataService.hideNavigation = false;
		window.location.reload();
	}

	RemoveFromGB(member: any) {
		member.isInGroupBilling = !member.isInGroupBilling;
		this.groupPortalDataService.getEditContactInfo(
			member.contactNo,
			true,
			member,
			true
		);
	}

	sendInvite(member: any) {
		this.removeMode = false;
		this.selectedMember = member;
		let deleteconfirmmodal = $(
			"[data-remodal-id=deleteParticipant]"
		).remodal();
		deleteconfirmmodal.open();
	}

	toggleStatusOptions(selectedval) {
		const mf = this.memberFilter;
		console.log(mf, selectedval);
		this.memberFilterType = selectedval;
		//this.memberFilterText = mf.value;
		// 	$('li.statusOptions').toggle();
		// return false;
	}

	changeStatusFilter(status) {
		//pga: Feature-2920 added support of submitted status in filter
		this.memberFilterType = status;
		switch (status) {
			case this.groupPortalDataService.statusCodeEnum.AllMembers: {
				this.memberFilterText = "All Members";
				break;
			}
			case this.groupPortalDataService.statusCodeEnum.ReadyForPayment: {
				this.memberFilterText = "Ready For Payment";
				break;
			}
			case this.groupPortalDataService.statusCodeEnum.Pending: {
				this.memberFilterText = "Application Pending";
				break;
			}
			case this.groupPortalDataService.statusCodeEnum.Paid: {
				this.memberFilterText = "Paid Members";
				break;
			}
			case this.groupPortalDataService.statusCodeEnum.Submitted: {
				this.memberFilterText = "Submitted";
				break;
			}
			case this.groupPortalDataService.statusCodeEnum.NotInGroupBill: {
				this.memberFilterText = "Not in Group Bill";
				break;
			}
		}
	}

	showProducts(npiNumber) {
		let expandElement = document.getElementById(npiNumber);
		if (expandElement.classList.contains("collapsed")) {
			expandElement.classList.add("expanded");
			expandElement.classList.remove("collapsed");
			$(".products" + npiNumber).show();
		} else {
			expandElement.classList.add("collapsed");
			expandElement.classList.remove("expanded");
			$(".products" + npiNumber).hide();
		}
	}

	resendInviteEmail(member) {
		this.groupPortalDataService.getContactInfoAndSendEmail(
			member.contactNo
		);
	}

	editContact(member) {
		this.scrollToTop();
		this.groupPortalDataService.getEditContactInfo(
			member.contactNo,
			true,
			member
		);
		this.groupPortalDataService.SetSlideOutType("editMember");
		//$('nav#sidebar').attr('style', 'margin-left: 0px');
		//$('nav#sidebar').removeClass('noseeme');

		//Angha is there any other way using whcih we can avoid the below code
		setTimeout(() => {
			this.SideNavDisplay('open');
			//this.sideNavService.refreshResidency$.next(true);
		}, 3000);

		//$('nav#sidebar').attr('style', 'height: ' + $(document).height() + 'px; margin-left:0px; margin-bottom: 10px; position:relative; animation: animateleft 0.4s;');
	}

	scrollToTop() {
		$("html,body").animate(
			{
				scrollTop: $(".gpTop").offset().top
			},
			"medium"
		);
	}

	public SantizeDate(date: string): string {
		if (date == "" || date == null) return "";
		return moment(date).format('MM/DD/YYYY');
	}

	memberAction() {
		this.removeMode
			? this.groupPortalDataService.RemoveContact(
				this.selectedMember.contactNo
			)
			: this.groupPortalDataService.ResendInviteEmail(
				this.selectedMember.contactNo
			);
		this.cancelModal();
	}

	cancelModal() {
		let deleteconfirmmodal = $(
			"[data-remodal-id=deleteParticipant]"
		).remodal();
		deleteconfirmmodal.close();
	}

	changeSortSubtotal() {
		this.groupPortalDataService.sortSubtotalAscending =
			!this.groupPortalDataService.sortSubtotalAscending ||
			this.groupPortalDataService.sortedBy !== "subtotal";
		this.groupPortalDataService.sortedBy = "subtotal";
		this.groupPortalDataService.changeSortSubtotal();
	}

	changeSortName() {
		this.groupPortalDataService.sortNameAscending =
			!this.groupPortalDataService.sortNameAscending ||
			this.groupPortalDataService.sortedBy !== "name";
		this.groupPortalDataService.sortedBy = "name";
		this.groupPortalDataService.changeSortName();
	}

	changeSortNPI() {
		this.groupPortalDataService.sortNPIAscending =
			!this.groupPortalDataService.sortNPIAscending ||
			this.groupPortalDataService.sortedBy !== "npi";
		this.groupPortalDataService.sortedBy = "npi";
		this.groupPortalDataService.changeSortNPI();
	}

	changeSortStatus() {
		this.groupPortalDataService.sortStatusAscending =
			!this.groupPortalDataService.sortStatusAscending ||
			this.groupPortalDataService.sortedBy !== "status";
		this.groupPortalDataService.sortedBy = "status";
		this.groupPortalDataService.changeSortStatus();
	}

	requestQuote() {
		this.printElem();
		// let htmlBody = $('div#body')[0].outerHTML;
		// htmlBody = this.commentStripper(htmlBody);
		// //use regex to clean up invalid html and junk from angular MB 3/13/2019
		// htmlBody = htmlBody.replace(/ _ngcontent-c5=""/g, '').replace(/ _ngcontent-c6""/g, '').replace(/<br>/g, "<br/>").replace(/title="ACEP"/g, 'title ="ACEP"/');

		// htmlBody = btoa(htmlBody);
		// let date = Date.now();
		// let param = { htmlbody: htmlBody, filename: 'Quote' + date, csspath: this._cssPath };
		// this.dataService.post(
		// 	param, this.globalDataOpsService.BasePath + "/utils/api/s3/HtmlToPdf");

	}
	commentStripper(html) {
		let newhtml = html;

		for (let index = 0; (index < newhtml.length && newhtml.search('<!--') > -1); index++) {
			//console.log('count at beginning: ' + newhtml.search('<!--'));
			let beginComment = newhtml.search('<!--');
			let endComment = newhtml.search('-->');
			let commmentLength = (endComment - beginComment);
			let removeMe = newhtml.substr(beginComment, commmentLength + 3);
			newhtml = newhtml.replace(removeMe, '');
			index = beginComment + 5;
		}
		return newhtml;
	}

	printElem() {
		let htmlBody = $('div#body')[0].outerHTML;
		//htmlBody = this.commentStripper(htmlBody);
		//use regex to clean up invalid html and junk from angular MB 3/13/2019
		htmlBody = htmlBody.replace(/ _ngcontent-c5=""/g, '').replace(/ _ngcontent-c6""/g, '').replace(/<br>/g, "<br/>").replace(/title="ACEP"/g, 'title ="ACEP"/').replace('=""', '').replace(/ hidden/g, '');
		let _cssPath = './assets/styles/quotestyles.css';
		//let _cssPath = 'https://webapps.acep.org/membership/groupportal/assets/styles/quotestyles.css'; //TODO: get this from an environemtn file
		let content = htmlBody;
		let mywindow = window.open();

		let documentContent = '<html><head>';
		//documentContent += '<link rel="stylesheet" type="text/css" href="' + _cssPath + '">';
		documentContent += '<style>' + this.rptStylesNewer() + '</style>';
		documentContent += '</head><body>';
		documentContent += content;
		documentContent += '</body></html>';

		mywindow.document.write(documentContent);
		mywindow.document.close();

		mywindow.focus();
		mywindow.print();
		mywindow.close();
		return true;
	}
	rptStylesNewer() {
		return `

			#body {
				margin: auto;
				padding: 0;
				width: 100%;
				max-width: 8in;
				height: 100%;
				background-color: rgb(255, 255, 255);
			}

			#quoteHtml {
				font-size: 12px;
				font-family: Arial, sans-serif;
				background-color: rgb(255, 255, 255);
				display: table;
				line-height: 1.4em;
				width: 100%;
			}

			table {
				border-spacing: 0;
				width: 100%;
				max-width: 8in;
			}

			#quoteHtml .qCustomerInfo {
				width: 100%;
				position: relative;
			}

			#quoteHtml .qCustomerInfo .qCustAddr {
				display: block;
				float: left;
				position: relative;
				width: 100%;
			}

			img {
				vertical-align: middle;
				border-top-style: none;
				border-right-style: none;
				border-bottom-style: none;
				border-left-style: none;
				max-width: 100%;
			}

			i,
			span {
				display: inline-block;
			}

			a {
				color: rgb(0, 123, 255);
				text-decoration-line: none;
				text-decoration-style: none;
				text-decoration-color: initial;
				background-color: transparent;
			}

			#quoteHtml .qCustomerInfo .qTermsGrid {
				display: block;
				width: 50%;
				position: absolute;
				right: 0;
				top: 5px;
				text-align: center;
				height: auto;
			}

			h1,
			h2,
			h3,
			h4,
			h5,
			h6 {
				margin-top: 0px;
				margin-bottom: 0.5em;
			}

			h1,
			h2,
			h3,
			h4,
			h5,
			h6,
			.h1,
			.h2,
			.h3,
			.h4,
			.h5,
			.h6 {
				margin-bottom: 0.5em;
				font-family: inherit;
				font-weight: 500;
				line-height: 1.2;
				color: inherit;
			}

			h1,
			.h1 {
				font-size: 2.5em;
			}

			h1,
			h2,
			h3,
			h4 {
				font-family: Arial, sans-serif;
				font-weight: bold;
				color: rgb(44, 95, 134);
			}

			b,
			strong {
				font-weight: bolder;
			}

			#quoteHtml .qCustomerInfo {
				padding-top: 10px;
				padding-right: 0;
				padding-bottom: 5px;
				padding-left: 0;
			}

			#quoteHtml .qCustomerInfo .qCustAddr {
				width: 50%;
				height: auto;
				line-height: 1.5em;
				padding-top: 35px;
			}

			#quoteHtml .qCustomerInfo .qTermsGrid {
				top: 0px;
				vertical-align: top;
			}

			table.table.tbl-amounts td {
				line-height: 1.5em;
				text-align: center;
				border: 1px solid #dee2e6;
				width: 50%;
				border-collapse: separate;
				border-spacing: 0px;
			}

			.table {
				margin-bottom: 1em;
				background-color: transparent;
			}

			th {
				text-align: inherit;
			}

			.table thead th {
				vertical-align: bottom;
			}

			.table>thead>tr>th {
				padding-top: 14px;
				padding-right: 8px;
				padding-bottom: 14px;
				padding-left: 8px;
				color: #fff !important;
			}

			.table th,
			.table td {
				padding-top: 5px;
				padding-bottom: 5px;
				vertical-align: top;
			}

			.text-nowrap {
				white-space: nowrap;
			}

			.table>tbody>tr>td {
				vertical-align: middle;
			}

			#quoteHtml .qGridResults {
				position: relative;
				width: 100%;
				top: 5px;
			}

			.table .table {
				background-color: rgb(255, 255, 255);
			}

			.table-primary,
			.table-primary>th,
			.table-primary>td {
				background-color: rgba(55, 80, 127, 1);
			}

			tr.nested-row td,
			tr.blue-row td {
				padding-top: 5px;
				padding-right: 5px;
				padding-bottom: 5px;
				padding-left: 5px;
			}

			tr.blue-row,
			tr.blue-row td {
				background-color: rgba(204, 219, 255, 1);
			}

			.mbrAmount {
				display: inline-flex;
			}

			.subtablesubheader {
				display: none;
			}

			thead.report-header {
				display: table-header-group;
			}

			tfoot.report-footer {
				display: table-footer-group;
				position: fixed;
				bottom: 0;
				width: 100%;
				left: 0;
			}

			tfoot.report-footer tr th.report-footer-cell {
				text-align: center;
				padding-top: 10px;
				font-size: smaller;
				position: absolute;
				bottom: 0;
				width: 100%;
			}

			.footer-info {
				padding-top: 25px;
				font-weight: normal;
			}

			table.table.tbl-grid {
				border-spacing: 0;
			}

			table.table.tbl-grid tr {
				page-break-inside: avoid !important;
			}

			th.text-nowrap.acepidcol,
			tr.blue-row td.dataacepid,
			tr.nested-row td.subblank {
				/* width: 102px */
				width: 13%;
			}

			th.text-nowrap.namecol,
			tr.blue-row td.datanamecol {
				/* width: 317px; */
				width: 43%;
			}

			th.text-nowrap.typecol,
			tr.blue-row td.datatypecol {
				text-align: center;
				/* width: 250px; */
				width: 32%;
			}

			th.text-nowrap.amountcell,
			tr.blue-row td.amountcell,
			tr.nested-row td.amountcell {
				/* width: 95px; */
				width: 12%;
				text-align: right;
			}

			tr.nested-row td.subdoubleup {
				/* width: 563px; */
				width: 75%;
			}

			th.text-nowrap.typecol span:first-child,
			tr.blue-row td:nth-of-type(3) span:first-child {
				text-align: right;
			}

			th.text-nowrap.typecol span,
			tr.blue-row td:nth-of-type(3) span {
				text-align: left;
				min-width: 75px;
			}

			th.newheader {
				position: relative;
				box-sizing: content-box;
				height: 100px;
			}

			.contact {
				vertical-align: top;
			}

			.flexedheader {
				display: block;
				height: 100%;
				width: 100%;
			}

			.flexedheader.forcontactquote {
				position: absolute;
				top: 70px;
				height: 30px;
			}

			.logorow {
				display: inline-flex;
				float: left;
				align-items: center;
				width: 100%;
				height: 60px;
			}

			.aceplogo,
			.emralogo {
				height: inherit;
			}

			.logorow .emralogo {
				padding-left: 25px;
				height: inherit;
			}

			.logorow .aceplogo img {
				float: left;
				height: inherit;
			}

			.logorow img {
				width: auto;
				height: 100%;
			}

			.contactquoterow {
				display: block;
				flex: auto;
				width: 100%;
			}

			.qQuote {
				display: block;
				position: absolute;
				bottom: 5px;
				right: 0;
				width: 50%;
				text-align: center;
			}

			.qQuote span {
				font-size: 2em;
				color: rgb(44, 95, 134);
			}
		`;
	}

	rptStyles() {
		return `
		#body {
			font-family: Arial, sans-serif;
			line-height: 1.4em;
			width: 8.25in;
			margin: auto;
		}

		#quoteHtml {
			width: 8.25in;
			display: table;
		}

		#body #quoteHtml {
			background-color: rgb(255, 255, 255);
		}

		.qRowBasic,
		#quoteHtml .qHeader,
		#quoteHtml .qCustomerInfo {
			display: inline-block;
			width: 100%;
			position: relative;
		}

		#quoteHtml .qHeader {
			padding-top: 5mm;
			padding-right: 5mm;
			padding-bottom: 0px;
			padding-left: 5mm;
		}

		.qRowFirstContainer,
		#quoteHtml .qHeader .qLogo,
		#quoteHtml .qCustomerInfo .qCustAddr {
			display: block;
			float: left;
			position: relative;
			width: 100%;
		}

		#quoteHtml .qHeader .qLogo {
			height: 24mm;
		}

		img {
			vertical-align: middle;
			border-top-style: none;
			border-right-style: none;
			border-bottom-style: none;
			border-left-style: none;
			max-width: 100%;
		}

		#quoteHtml .qHeader .qLogo img {
			width: 65mm;
			float: left;
			max-width: 100%;
		}

		i,
		span {
			display: inline-block;
		}

		#quoteHtml .qHeader .qLogo img+span {
			position: absolute;
			bottom: 0px;
			left: 0px;
		}

		a {
			color: rgb(0, 123, 255);
			text-decoration-line: none;
			text-decoration-style: initial;
			text-decoration-color: initial;
			background-color: transparent;
		}

		a:hover {
			color: rgb(0, 86, 179);
			text-decoration-line: underline;
			text-decoration-style: initial;
			text-decoration-color: initial;
		}

		a:not([href]):not([tabindex]) {
			color: inherit;
			text-decoration-line: none;
			text-decoration-style: initial;
			text-decoration-color: initial;
		}

		a:not([href]):not([tabindex]):focus {
			outline-color: initial;
			outline-style: initial;
			outline-width: 0px;
		}

		.qRowSecondContainer,
		#quoteHtml .qHeader .qTermsGridHeader,
		#quoteHtml .qCustomerInfo .qTermsGrid {
			display: block;
			width: 100mm;
			position: absolute;
			right: 5mm;
			top: 5mm;
			text-align: center;
			height: auto;
		}

		#quoteHtml .qHeader .qTermsGridHeader {
			height: 24mm;
		}

		#quoteHtml .qHeader .qTermsGridHeader span {
			text-align: center;
		}

		.qTermsGridHeader span h1 {
			margin-bottom: 0;
		}

		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			margin-top: 0px;
			margin-bottom: 0.5rem;
		}

		h1,
		h2,
		h3,
		h4,
		h5,
		h6,
		.h1,
		.h2,
		.h3,
		.h4,
		.h5,
		.h6 {
			margin-bottom: 0.5rem;
			font-family: inherit;
			font-weight: 500;
			line-height: 1.2;
			color: inherit;
		}

		h1,
		.h1 {
			font-size: 2.5rem;
		}

		h1,
		h2,
		h3,
		h4 {
			font-family: Arial, sans-serif;
			font-weight: bold;
			color: rgb(44, 95, 134);
			margin-top: 40px;
			margin-bottom: 40px;
		}

		b,
		strong {
			font-weight: bolder;
		}

		#quoteHtml .qCustomerInfo {
			padding-top: 10mm;
			padding-right: 5mm;
			padding-bottom: 5mm;
			padding-left: 5mm;
		}

		#quoteHtml .qCustomerInfo .qCustAddr {
			width: 78mm;
			height: 32mm;
			line-height: 1.5em;
		}

		#quoteHtml .qCustomerInfo .qTermsGrid {

			top: 0px;
		}
		table.table.tbl-amounts td {
			line-height: 1.5em;
			text-align: center;
			border: 1px solid #dee2e6;
		}

		table {
			border-collapse: collapse;
		}

		.table {
			width: 100%;
			margin-bottom: 1rem;
			background-color: transparent;
		}

		.table th,
		.table td {
			padding-top: 0.5rem;
			padding-bottom: 0.5rem;
			vertical-align: top;
		}

		.text-nowrap {
			white-space: nowrap;
		}

		.table>tbody>tr>td {
			vertical-align: middle;
		}

		.container-fluid {
			width: 100%;
			padding-right: 0px;
			padding-left: 0px;
			margin-right: auto;
			margin-left: auto;
		}

		#quoteHtml .qGridResults {
			position: relative;
			width: 100%;
			top: 5mm;
		}

		.table .table {
			background-color: rgb(255, 255, 255);
		}



		.table-primary,
		.table-primary>th,
		.table-primary>td {
			background-color: rgba(55, 80, 127, 1);
		}

		#quoteHtml .qGridResults table tbody tr table thead tr,
		#quoteHtml .qGridResults table tbody tr table thead tr th {
			color: rgb(255, 255, 255);

			background-color: rgb(55, 80, 127);
			padding-top: 5px;
			padding-right: 5px;
			padding-bottom: 5px;
			padding-left: 5px;
		}

		th {
			text-align: inherit;
		}

		.table thead th {
			vertical-align: bottom;

		}

		.table-primary th,
		.table-primary td,
		.table-primary thead th,
		.table-primary tbody+tbody {}

		.table>thead>tr>th {
			padding-top: 14px;
			padding-right: 8px;
			padding-bottom: 14px;
			padding-left: 8px;
			color: #fff;
		}

		.amountcell {
			float: right;
		}

		tr.nested-row td,
		tr.blue-row td {

			padding-top: 5px;
			padding-right: 5px;
			padding-bottom: 5px;
			padding-left: 5px;
		}

		#quoteHtml .qGridResults table tbody tr table tr.blue-row,
		tr.blue-row,
		tr.blue-row td {

			background-color: rgba(204, 219, 255, 1);
		}

		.mbrAmount {
			display: inline-flex;
		}

		.subtablesubheader {
			display: none;
		}

		th.text-nowrap.acepidcol,
		tr.blue-row td:nth-of-type(1) {
			width: 13%;
		}

		th.text-nowrap.namecol,
		tr.blue-row td:nth-of-type(2) {
			width: 43%;
		}
		th.text-nowrap.typecol,
		tr.blue-row td:nth-of-type(3) {
			text-align: center;
			width: 35%;
		}

		th.text-nowrap.typecol span:first-child,
		tr.blue-row td:nth-of-type(3) span:first-child {
			text-align: right;
		}

		th.text-nowrap.typecol span,
		tr.blue-row td:nth-of-type(3) span {
			display: inline-block;
			text-align: left;
			min-width: 100px;
		}

		body #quoteHtml {
			background-color: #fff !important;
		}

		table.report-container {
			width: 100%;
		}

		thead.report-header {
			display: table-header-group;
		}

		tfoot.report-footer {
			display: table-footer-group;
			text-align: center;
			padding-top: 10mm;
			position: fixed;
			bottom: 0;
		}


		table.table.tbl-grid tr
		{
			page-break-inside: avoid !important;
		}



		`;
	}

}
